import { render } from "./ProfileConsultant.vue?vue&type=template&id=22e1a45a&scoped=true"
import script from "./ProfileConsultant.vue?vue&type=script&lang=js"
export * from "./ProfileConsultant.vue?vue&type=script&lang=js"

import "./ProfileConsultant.vue?vue&type=style&index=0&id=22e1a45a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e1a45a"]])

export default __exports__